import React from 'react'

export default function LoadingUserIconPlaceholder() {
  return (
    <div className="a-user-icons__item">
      <div className="a-user-icons__item-link">
        <div className="a-user-icons__item-icon a-user-icon a-placeholder"></div>
      </div>
    </div>
  )
}
